import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'BEX Vendor',
      metaTags: [
        {
          name: 'description',
          content: 'BEX Vendor is the platform for manufacturers, producers to sell the project on BEX Social Commerce App.'
        },
        {
          property: 'og:description',
          content: 'BEX Vendor is the platform for manufacturers, producers to sell the project on BEX Social Commerce App.'
        }
      ]
    }
  },
  {
    path: '/about',
    name: 'About',    
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    meta: {
      title: 'About BEX Vendor',
      metaTags: [
        {
          name: 'description',
          content: 'BEX Vendor is the platform for manufacturers, producers to sell the project on BEX Social Commerce App.'
        },
        {
          property: 'og:description',
          content: 'BEX Vendor is the platform for manufacturers, producers to sell the project on BEX Social Commerce App.'
        }
      ]
    }
  },
  {
    path: '/how-bex-works',
    name: 'How BEX Works',
    component: () => import('../views/HowItWorks.vue'),
    meta: {
      title: 'How BEX Works',
      metaTags: [
        {
          name: 'description',
          content: 'BEX Vendor is the platform for manufacturers, producers to sell the project on BEX Social Commerce App.'
        },
        {
          property: 'og:description',
          content: 'BEX Vendor is the platform for manufacturers, producers to sell the project on BEX Social Commerce App.'
        }
      ]
    }
  },
  {
    path: '/calculator',
    name: 'Price Calculator',
    component: () => import('../views/Calculator.vue'),
    meta: {
      title: 'Price Calculator',
      metaTags: [
        {
          name: 'description',
          content: 'BEX Vendor is the platform for manufacturers, producers to sell the project on BEX Social Commerce App.'
        },
        {
          property: 'og:description',
          content: 'BEX Vendor is the platform for manufacturers, producers to sell the project on BEX Social Commerce App.'
        }
      ]
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
    meta: {
      title: 'BEX Vendor Contact',
      metaTags: [
        {
          name: 'description',
          content: 'BEX Vendor is the platform for manufacturers, producers to sell the project on BEX Social Commerce App.'
        },
        {
          property: 'og:description',
          content: 'BEX Vendor is the platform for manufacturers, producers to sell the project on BEX Social Commerce App.'
        }
      ]
    }
  }, 
  {
    path: '/signup',
    name: 'Create Account',
    component: () => import('../views/Signup.vue'),
    meta: {
      title: 'Create Vendor Account',
      metaTags: [
        {
          name: 'description',
          content: 'BEX Vendor is the platform for manufacturers, producers to sell the project on BEX Social Commerce App.'
        },
        {
          property: 'og:description',
          content: 'BEX Vendor is the platform for manufacturers, producers to sell the project on BEX Social Commerce App.'
        }
      ]
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if(previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
  .forEach(tag => document.head.appendChild(tag));

  next();
});

// ...

export default router
